import React, { Component } from 'react';
import {
  FacetContainerContext,
  FacetContainerProps as FacetContainerPropsFromElastic,
} from '@elastic/react-search-ui-views';
import { helpers } from '@elastic/search-ui';
import { withSearch } from '@elastic/react-search-ui';
import { __ } from '@wordpress/i18n';

const { markSelectedFacetValuesFromFilters } = helpers;

interface FacetContainerState {
  searchTerm: string;
  isOpen: boolean;
}

type CustomFacetContainerProps = FacetContainerPropsFromElastic & {
  onTotalSelectedChange?: (total: number) => void;
  showGlobalFilterSummary?: boolean;
  onFilterChange?: () => void;
  toolparamdescription?: string;
  valueLabels?: Record<string, string>;
  defaultOpen?: boolean;
};

class FacetContainer extends Component<
  CustomFacetContainerProps,
  FacetContainerState
> {
  static defaultProps = {
    filterType: 'any',
    isFilterable: false,
  };

  private static instanceCounter = 0;
  private instanceId: number;

  constructor(props) {
    super(props);
    this.state = { searchTerm: '', isOpen: !!props.defaultOpen };
    FacetContainer.instanceCounter += 1;
    this.instanceId = FacetContainer.instanceCounter;
  }

  handleFacetSearch = (searchTerm) => {
    this.setState({ searchTerm });
  };

  handleToggle = (e: React.SyntheticEvent<HTMLDetailsElement>) => {
    this.setState({ isOpen: e.currentTarget.open });
  };

  handleCheckboxChange = (checked, value) => {
    const {
      addFilter, removeFilter, field, filterType, filters, onFilterChange,
    } = this.props;
    const isSelected = filters.some(
      (filter) => filter.field === field && filter.values.includes(value),
    );

    let filterApplied = false;

    if (checked && !isSelected) {
      addFilter(field, value, filterType);
      filterApplied = true;
    } else if (!checked && isSelected) {
      removeFilter(field, value);
      filterApplied = true;
    }

    if (filterApplied && onFilterChange) {
      onFilterChange();
    }
  };

  render() {
    const { searchTerm, isOpen } = this.state;
    const {
      addFilter,
      className,
      facets,
      field,
      filterType,
      filters,
      label,
      removeFilter,
      setFilter,
      isFilterable,
      toolparamdescription,
      valueLabels,
      defaultOpen,
      ...rest
    } = this.props;

    if (!facets) return null;

    const facetsForField = facets[field];
    if (!facetsForField) return null;

    const facet = facetsForField[0];
    let facetValues = markSelectedFacetValuesFromFilters(
      facet,
      filters,
      field,
      filterType,
    ).data;

    if (!facetValues.length) return null;

    if (searchTerm.trim()) {
      facetValues = facetValues.filter((option) => {
        let valueToSearch = '';
        if (typeof option.value === 'string') {
          valueToSearch = option.value.toLowerCase();
        }
        return valueToSearch.includes(searchTerm.toLowerCase());
      });
    }

    return (
      <div className="job-accordion">
        {this.props.showGlobalFilterSummary
        && this.fliterLog({ className: `job-filter-counter job-filter-counter-${this.instanceId}` })}
        <details className="job-details" open={isOpen} onToggle={this.handleToggle}>
          <summary className="job-summary">
            {label} <span className="summary-icon"></span>
          </summary>
          <fieldset className="job-facet">
            {facetValues.map((option) => {
              const isChecked = filters.some(
                (filter) => filter.field === field && filter.values.includes(option.value),
              );

              const declarativeDescription = `search for ${option.value} jobs`;

              return (
                <div key={option.value} className="job-multi-checkbox-facet__option">
                  <label className="job-multi-checkbox-facet__option-label">
                    <div className="job-multi-checkbox-facet__option-input-wrapper">
                      <input
                        className="job-multi-checkbox-facet__checkbox"
                        name={`${field}[]`}
                        value={option.value}
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => this.handleCheckboxChange(e.target.checked, option.value)}
                        data-gtm-form-interact-field-id="2"
                        toolparamdescription={declarativeDescription}
                      />
                      <div className="checkbox__checkmark"></div>
                      <span className="job-multi-checkbox-facet__input-text">
                        {valueLabels?.[option.value] ?? __(option.value, 'wp-plugin-jobs')} <span className="job-multi-checkbox-facet__input-count">({option.count})</span>
                      </span>
                    </div>
                  </label>
                </div>
              );
            })}
          </fieldset>
        </details>
      </div>
    );
  }
}

export default withSearch<CustomFacetContainerProps, FacetContainerContext>(
  ({ filters, facets, addFilter, removeFilter, setFilter, a11yNotify }) => ({
    filters,
    facets,
    addFilter,
    removeFilter,
    setFilter,
    a11yNotify,
  }),
)(FacetContainer);
